// extracted by mini-css-extract-plugin
module.exports = {"root":"Circle-root-1RVaQ","active":"Circle-active-3g1h6","completed":"Circle-completed-3sZNX","icon":"Circle-icon-2Wv4u"};